import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["href"]

import { Capacitor } from '@capacitor/core'
import { PDFsModel } from '../models/PDFsModel'
import { WriteFileOptions } from '@capacitor/filesystem'
import { generateFileNameFromURL } from '../models/PDFsModel'
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useDevicePDFsStore } from '../store/useDevicePDFsStore'
import TableCellRender from './TableCellRender.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'TaskAttachment',
  props: {
    filterData: {},
    attachment: {},
    truncate: { type: Boolean, default: false }
  },
  setup(__props: any) {

/**
 * This component handles the logic for rendering task attachment links
 */
const props = __props
const isNative = Capacitor.isNativePlatform()
const open = (src: WriteFileOptions['path']) => PDFsModel().openPDF(src)
const { getPDFs } = storeToRefs(useDevicePDFsStore())
const renderText = (url: string) => {
  return generateFileNameFromURL(url)
    .replaceAll('+Instructions', '')
    .replaceAll('InstructionFiles', '')
    .replaceAll('%', '')
}
const onDevice = computed(() => {
  if (!props.attachment) return false
  return getPDFs.value.includes(generateFileNameFromURL(props.attachment))
})

return (_ctx: any,_cache: any) => {
  return (_ctx.attachment)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (_unref(isNative))
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass([onDevice.value ? 'text-primary underline' : 'text-black', "ellipsis"]),
              style: _normalizeStyle(
        _ctx.truncate ? 'max-width: 7em; display: block; direction: rtl; text-align: left' : undefined
      ),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (open(_ctx.attachment)))
            }, [
              _createVNode(TableCellRender, {
                data: renderText(_ctx.attachment),
                "data-type": "string",
                filter: _ctx.filterData
              }, null, 8, ["data", "filter"])
            ], 6))
          : (_openBlock(), _createElementBlock("span", {
              key: 1,
              class: "text-primary underline",
              target: "_blank",
              rel: "noopener noreferrer",
              href: props.attachment
            }, [
              _createVNode(TableCellRender, {
                data: _unref(generateFileNameFromURL)(_ctx.attachment),
                "data-type": "string",
                filter: _ctx.filterData
              }, null, 8, ["data", "filter"])
            ], 8, _hoisted_1))
      ], 64))
    : _createCommentVNode("", true)
}
}

})